export const environment = {
  production: true,
  envName: 'uat',
  apiBaseUrl: 'https://uatapi.arrivae.com',
  marketBaseUrl: 'https://qa-marketing-api.arrivae.com',
  uiBaseUrl: 'https://arrivae-uat-product.firebaseapp.com',
  uihrefUrl:'https://delta-uat.arrivae.com',
  pptUrl: 'uat'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts